var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExerciseGaol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7967 8.29369C12.9489 8.49435 12.9731 8.76439 12.8594 8.98929C12.7474 9.21753 12.5158 9.36301 12.2616 9.36385H3.12102V16.0523H4.23547C4.60502 16.0523 4.90432 16.3516 4.90432 16.7212C4.90432 17.0907 4.60502 17.39 4.23547 17.39H0.66801H0.668846C0.299301 17.39 0 17.0907 0 16.7212C0 16.3516 0.299301 16.0523 0.668846 16.0523H1.7833V0.668846C1.7833 0.299301 2.08261 0 2.45215 0C2.8217 0 3.121 0.299301 3.121 0.668846V0.89208H12.2616C12.5158 0.892916 12.7474 1.03839 12.8594 1.26663C12.9731 1.49154 12.9489 1.76075 12.7967 1.96223L10.4248 5.12753L12.7967 8.29369Z",
    fill: "#FFEB33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExerciseGaol);
export default __webpack_public_path__ + "static/media/exerciseGaol.32d9c597ad16c75ffe33c52d7eb6124a.svg";
export { ForwardRef as ReactComponent };